// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title___2qCcC","button":"styles__button___33-hS","content":"styles__content___176fV"};